var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"1000px","margin":"10px auto"}},[_c('manage-job')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }